import React from 'react';
import { type DragEndEvent } from '@dnd-kit/core';
import translate from '@/lib/intl/translate';
import showErrorMessage from '@/utils/toasts/showErrorMessage';
import useSortedCustomFields from '../../hooks/useSortedCustomFields';
import type CustomFieldsCategory from '../../types/CustomFieldsCategory';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import CustomFieldsSection from './CustomFieldsSection';

export default function CustomFieldsList() {
  const { sortedCustomFields = [], updateOrder } = useSortedCustomFields();
  const [expandedItem, setExpandedItem] = React.useState<string>('');

  const onDragEnd = React.useCallback(
    (category: CustomFieldsCategory) => (e: DragEndEvent) => {
      const { active, over } = e;
      const fieldIds = category.customFields.map((item) => item.customFieldId);
      const oldIndex = fieldIds.indexOf(active.id as string);
      const newIndex = over && fieldIds.indexOf(over.id as string);
      if (newIndex === null || oldIndex === newIndex) return;
      try {
        updateOrder({ category: category.value, newIndex, oldIndex });
      } catch (error) {
        showErrorMessage({ message: translate('CUSTOM_FIELDS_EDIT_ERROR') });
      }
    },
    [updateOrder],
  );

  return (
    <>
      {sortedCustomFields.map((category: CustomFieldsCategory) => (
        <CustomFieldsSection
          key={category.value}
          {...category}
          expandedItem={expandedItem}
          onDragEnd={onDragEnd(category)}
          onExpand={setExpandedItem}
        />
      ))}
    </>
  );
}
